import { useEffect, useState } from "react";
import { Menu, Spin } from "antd";
import { 
    AppstoreOutlined, 
    HomeOutlined, 
    PlusSquareOutlined, 
    StarOutlined, 
    UnorderedListOutlined, 
    ApartmentOutlined, 
    ClusterOutlined, 
    IdcardOutlined, 
    TagsOutlined, 
    TeamOutlined, 
    BankOutlined, 
    AuditOutlined,
    OrderedListOutlined,
    BarChartOutlined,
    FileProtectOutlined
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import "./sideMenuAdmin.css";
import { getFromLocalStorage } from "../../helpers/EncryptData";
import axios from "axios";
import { apiUrl } from '../../utility/Connections';

const { SubMenu } = Menu;

const SideMenuAdmin = (props) => {
    const [orgData, setOrgData] = useState(null);
    const [orgServices, setOrgServices] = useState(null);
    const [current, setCurrent] = useState("create");
    const [openKeys, setOpenKeys] = useState([]); 
    const [showLoading, setShowLoading] = useState(false);
    const navigate = useNavigate();

    const menuItemsByService = {
        1: [
            { key: "modulo-competencias/competencias", label: "Competencias", icon: <StarOutlined /> },
            { key: "modulo-competencias/evaluaciones", label: "Evaluaciones", icon: <AuditOutlined /> }
        ],
        2: [
            { key: "modulo-liderazgo/atributos-lider", label: "Atributos del Líder", icon: <StarOutlined /> },
            { key: "modulo-liderazgo/evaluaciones", label: "Evaluaciones", icon: <AuditOutlined /> },
            { key: "modulo-liderazgo/informes", label: "Informes", icon: <BarChartOutlined /> }
        ],
        3: [
            { key: "modulo-cultura/atributos-cultura", label: "Atributos / Comportamientos / Palancas", icon: <StarOutlined /> },
            { key: "modulo-cultura/evaluaciones", label: "Evaluaciones", icon: <AuditOutlined /> },
            { key: "modulo-cultura/informes", label: "Informes", icon: <BarChartOutlined /> }
        ]
    };

    const buildSecuritySelfcareItems = ({ hasSrv6, hasSrv7, isSuperAdmin }) => {
        return {
            dashboard: { key: "modulo-seguridad-autocuidado/dashboard", label: "Dashboard", icon: <BarChartOutlined /> },
            autocuidado: hasSrv6
                ? [
                    ...(isSuperAdmin ? [{ key: "modulo-autocuidado/atributos-autocuidado", label: "Atributos", icon: <StarOutlined /> }] : []),
                    { key: "modulo-autocuidado/evaluaciones", label: "Evaluaciones", icon: <AuditOutlined /> },
                    { key: "modulo-autocuidado/informes", label: "Informes", icon: <BarChartOutlined /> },
                ]
                : [],
            seguridad: hasSrv7
                ? [
                    ...(isSuperAdmin ? [{ key: "modulo-seguridad/atributos-seguridad", label: "Atributos", icon: <StarOutlined /> }] : []),
                    { key: "modulo-seguridad/evaluaciones", label: "Evaluaciones", icon: <AuditOutlined /> },
                    { key: "modulo-seguridad/informes", label: "Informes", icon: <BarChartOutlined /> },
                ]
                : [],
        };
    };

    const handleClick = (e) => {
        setCurrent(e.key);
        navigate(e.key);
    };

    const handleOpenChange = (keys) => {
        setOpenKeys(keys.length ? [keys[keys.length - 1]] : []);
    };

    useEffect(() => {
        if (props.showOrganizationMenu) {
            const current_org = getFromLocalStorage("current_org");
            if (current_org) {
                setOrgData(current_org);
        
                setShowLoading(true);
                const token = localStorage.getItem('access_token');
                const headers = {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    },
                }
        
                axios.get(`${apiUrl}/rel-org-srv/get-rel-org-srv-by-org-id/${current_org.org_id}/`, headers)
                    .then(function (response) {
                        setOrgServices(response.data.services);
                        setShowLoading(false);
                    })
                    .catch(function (error) {
                        console.error('There was an error!', error);
                    });
            }
        }
    }, [props.showOrganizationMenu]); 

    return (
        <Menu
            onClick={handleClick}
            selectedKeys={[current]}
            mode="inline"
            className="sideMenuAdmin"
            openKeys={openKeys}
            onOpenChange={handleOpenChange}
        >
            {/* Menú para SuperAdmin */}
            {props.isSuperAdmin && (
                <>
                    <Menu.ItemGroup key="group0" title="Configuración" />
                    <Menu.Item key="servicios" icon={<AppstoreOutlined />}>
                        Servicios
                    </Menu.Item>
                    <Menu.Item key="configuracion/terminos-condiciones" icon={<FileProtectOutlined />}>
                        Términos y Condiciones
                    </Menu.Item>
                    <Menu.ItemGroup key="group1" title="Organizaciones" />
                    <Menu.Item key="organizaciones/crear" icon={<PlusSquareOutlined />}>
                        Crear Organización
                    </Menu.Item>
                    <Menu.Item key="organizaciones/lista" icon={<UnorderedListOutlined />}>
                        Listado de Organizaciones
                    </Menu.Item>
                    <Menu.ItemGroup key="group2" title="Evaluaciones" />
                    <Menu.Item key="evaluaciones/respuestas" icon={<OrderedListOutlined />}>
                        Opciones de Respuesta
                    </Menu.Item>
                </>
            )}

            {props.showOrganizationMenu && (props.isAdmin || props.isSuperAdmin) && orgData && (
                <Menu.ItemGroup key="group3" title={orgData.org_name} />
            )}

            {/* Menú de Organización (Colapsable) */}
            {props.showOrganizationMenu && (props.isAdmin || props.isSuperAdmin) && orgData && (
                <>
                    <SubMenu key="organizationMenu" title="Información General">
                        <Menu.Item key="organizacion/info" icon={<BankOutlined />}>
                            Organización
                        </Menu.Item>
                        <Menu.Item key="organizacion/sedes" icon={<HomeOutlined />}>
                            Sedes
                        </Menu.Item>
                        <Menu.Item key="organizacion/gerencias" icon={<ApartmentOutlined />}>
                            Gerencias
                        </Menu.Item>
                        <Menu.Item key="organizacion/areas" icon={<ClusterOutlined />}>
                            Áreas
                        </Menu.Item>
                        <Menu.Item key="organizacion/cargos" icon={<IdcardOutlined />}>
                            Cargos
                        </Menu.Item>
                        <Menu.Item key="organizacion/categorias-cargos" icon={<TagsOutlined />}>
                            Categorías de cargo
                        </Menu.Item>
                        <Menu.Item key="organizacion/colaboradores" icon={<TeamOutlined />}>
                            Colaboradores
                        </Menu.Item>
                    </SubMenu>
                    {showLoading ? (
                        <Menu.Item key="loading" disabled>
                            <Spin size="small" style={{ marginRight: 8 }} />
                            Cargando módulos...
                        </Menu.Item>
                    ) : (
                        (() => {
                            const activeServices = (orgServices || []).filter(service => service.ros_active);
                            const hasSrv6 = activeServices.some(s => s.srv_id === 6);
                            const hasSrv7 = activeServices.some(s => s.srv_id === 7);

                            const servicesToRender = activeServices.reduce((acc, service) => {
                                if (service.srv_id === 6 || service.srv_id === 7) {
                                    const alreadyAdded = acc.some(s => s.srv_id === "security-selfcare");
                                    if (!alreadyAdded) {
                                        acc.push({ srv_id: "security-selfcare", srv_service: "Seguridad y Autocuidado" });
                                    }
                                    return acc;
                                }

                                acc.push(service);
                                return acc;
                            }, []);

                            return servicesToRender.map(service => {
                                const isSecuritySelfcare = service.srv_id === "security-selfcare";
                                const securitySelfcare = isSecuritySelfcare
                                    ? buildSecuritySelfcareItems({ hasSrv6, hasSrv7, isSuperAdmin: props.isSuperAdmin })
                                    : null;

                                const items = isSecuritySelfcare
                                    ? null
                                    : menuItemsByService[service.srv_id];

                                return (
                                    <SubMenu
                                        key={service.srv_id}
                                        title={service.srv_service}
                                    >
                                        {isSecuritySelfcare ? (
                                            <>
                                                <Menu.Item key={securitySelfcare.dashboard.key} icon={securitySelfcare.dashboard.icon}>
                                                    {securitySelfcare.dashboard.label}
                                                </Menu.Item>

                                                {securitySelfcare.autocuidado.length > 0 && (
                                                    <Menu.ItemGroup key="security-selfcare-autocuidado" title="Autocuidado">
                                                        {securitySelfcare.autocuidado.map(item => (
                                                            <Menu.Item key={item.key} icon={item.icon}>{item.label}</Menu.Item>
                                                        ))}
                                                    </Menu.ItemGroup>
                                                )}

                                                {securitySelfcare.seguridad.length > 0 && (
                                                    <Menu.ItemGroup key="security-selfcare-seguridad" title="Seguridad">
                                                        {securitySelfcare.seguridad.map(item => (
                                                            <Menu.Item key={item.key} icon={item.icon}>{item.label}</Menu.Item>
                                                        ))}
                                                    </Menu.ItemGroup>
                                                )}
                                            </>
                                        ) : items ? (
                                            items.map(item => (
                                                <Menu.Item key={item.key} icon={item.icon}>{item.label}</Menu.Item>
                                            ))
                                        ) : (
                                            <Menu.Item key={`${service.srv_id}-default`}>
                                                No hay módulos disponibles
                                            </Menu.Item>
                                        )}
                                    </SubMenu>
                                );
                            });
                        })()
                    )}
                    {/* <SubMenu key="evaluacionCompetenciasMenu" title="Evaluación Competencias">
                        <Menu.Item key="organizacion/info" icon={<BankOutlined />}>
                            Organización
                        </Menu.Item>
                    </SubMenu> */}
                </>
            )}
        </Menu>
    );
};

export default SideMenuAdmin;
